import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {CollectionDetail} from "./collection-detail";

const CollectionDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/collections');
    }

    return (
        <CollectionDetail id={id ? parseInt(id) : null} onClose={onClose}/>
    )

});

export default CollectionDetailPage;
